import { render, staticRenderFns } from "./SwipeCard.vue?vue&type=template&id=f55b4862&scoped=true"
import script from "./SwipeCard.vue?vue&type=script&lang=js"
export * from "./SwipeCard.vue?vue&type=script&lang=js"
import style0 from "./SwipeCard.vue?vue&type=style&index=0&id=f55b4862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55b4862",
  null
  
)

export default component.exports